import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import JobKeyLogo from "@/components/JobKeyLogo";
import LangSelect from "@/components/LangSelect";
import { useI18n } from "@/i18n";

export default function AuthShell({ title, sub, children, wide = false }) {
  const { t } = useI18n();
  return (
    <div className="grid min-h-screen lg:grid-cols-2" data-testid="auth-shell">
      <div className="relative hidden flex-col justify-between overflow-hidden bg-night p-12 lg:flex grain">
        <Link to="/" data-testid="auth-shell-logo"><JobKeyLogo dark /></Link>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-accent-bright">
            {t("Script → Video → Translate → Look → Shoot → Results")}
          </p>
          <h2 className="mt-6 max-w-md font-display text-4xl font-extrabold leading-tight text-night-ink">
            {t("Your whole short-video workflow, in one place.")}
          </h2>
          <ul className="mt-8 space-y-3 text-sm text-night-soft">
            <li className="flex gap-3"><span className="text-accent-bright">01</span> {t("Scripts, hooks and scene plans in minutes")}</li>
            <li className="flex gap-3"><span className="text-accent-bright">02</span> {t("Translate voiceovers into regional languages")}</li>
            <li className="flex gap-3"><span className="text-accent-bright">03</span> {t("Regional look briefs and a posting checklist")}</li>
            <li className="flex gap-3"><span className="text-accent-bright">04</span> {t("Track views, downloads and subscriptions")}</li>
          </ul>
        </div>
        <p className="font-mono text-xs text-night-soft">© {new Date().getFullYear()} Jobky · jobky.in</p>
      </div>
      <div className="flex flex-col items-center justify-center bg-bg px-5 py-14">
        <div className={`w-full ${wide ? "max-w-md" : "max-w-sm"}`}>
          <div className="mb-6 flex items-center justify-between lg:hidden">
            <Link to="/"><JobKeyLogo /></Link>
            <LangSelect />
          </div>
          <div className="mb-8 hidden justify-end lg:flex">
            <LangSelect />
          </div>
          <h1 className="font-display text-3xl font-extrabold tracking-tight">{title}</h1>
          <p className="mt-2 text-sm text-muted">{sub}</p>
          <div className="mt-8">{children}</div>
        </div>
      </div>
    </div>
  );
}
